module.exports = __webpack_public_path__ + "media/newstyle/images/icon-select-arrow-d2ce774157b89ae8ba01617916fc2eef.svg";